import Page from '../../components/layouts/page'
import ActivityLogsTable from '../../components/activity_logs_table'

export default function ActivityLogs() {
  return (
    <Page title='Activity Logs'>
      <ActivityLogsTable />
    </Page>
  )
}
